import React, { useEffect, useState } from "react";
import "./PointsTransaction.css";
import { DeleteOutline, Edit } from "@mui/icons-material";
import Paper from "@mui/material/Paper";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import NotFound from "../SharedModule/NotFound";
import { toast } from "react-toastify";
import DeleteModal from "../Modals/DeleteModal";

const Coupons = () => {
  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const goToCreateCoupon = () => {
    navigate("./createNewCoupon");
  };

  const [coupons, setCoupons] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const getCoupons = async () => {
    try {
      let response = await axios.get(`${newBaseUrl}/api/portal/coupons`, {
        headers,
      });
      console.log(response.data.data.coupons);
      setCoupons(response.data.data.coupons);
    } catch (error) {
      console.log(error);
    }
  };

  const [showDelete, setShowDelete] = useState(false);

  const [editCouponId, setEditCouponId] = useState(null);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditCouponId(null);
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setEditCouponId(id);
  };

  const deleteCoupon = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/coupons/${editCouponId}`,
        {
          headers,
        }
      );
      toast.warning("Category Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getCoupons();
    } catch (error) {
      toast.error("Failed To Delete This Category.");
      console.log(error.message);
    }
  };

  const columns = [
    {
      field: "Code",
      headerName: "Coupon Code",
      flex: 0.8,
      minWidth: 100,
    },
    {
      field: "Discount",
      headerName: "Discount Value",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Type",
      headerName: "Discount Type",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "Limit",
      headerName: "Usage Limit",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Created",
      headerName: "Created At",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Expired",
      headerName: "Expired At",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 125,
      renderCell: (params) => {
        const handleEdit = async (e) => {
          e.stopPropagation();
          navigate(`/Coupons/${params.row.id}`);
        };
        const handleDelete = (event) => {
          event.stopPropagation();
          confirmDelete(params.row.id);
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={handleEdit}
              color="default"
              style={{ width: "22%" }}
              aria-label="edit"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              style={{ width: "22%" }}
              aria-label="delete"
            >
              <DeleteOutline />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  const filteredRows = coupons
    .filter((template) => {
      const matchesSearch =
        template.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
        template.discount_type.toLowerCase().includes(searchTerm.toLowerCase());

      return matchesSearch;
    })
    .map((template) => ({
      id: template.id,
      Code: template.code,
      Discount: template.discount_value,
      Type: template.discount_type,
      Limit: template.max_total_usage || "-",
      Created: formatDate(template.created_at),
      Expired: formatDate(template.valid_until) || "Undefined",
      Actions: "",
      rawData: template,
    }));

  useEffect(() => {
    getCoupons();
  }, []);

  return (
    <>
      {/* delete coupon */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={"Are you sure you want to delete this coupon?"}
        deleteFunction={deleteCoupon}
      />
      <div className="m-4">
        {/* offers head  */}
        <div className="notifications-display d-flex justify-content-between align-items-center">
          <p className="my-sm-2 fs-5 my-md-0 fw-bold">Coupons</p>
          <button
            onClick={() => goToCreateCoupon()}
            className="btn border border-1 text-muted p-2"
          >
            <i className="fa-solid fa-plus fw-light mx-1"></i>
            Create New Coupon
          </button>
        </div>
        {/* offers search  */}
        <div className="notif-search d-flex justify-content-center justify-content-md-end align-items-center my-3">
          {/* text search */}
          <FormControl sx={{ width: "40ch" }} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">
              Search by Code, type ..
            </InputLabel>
            <OutlinedInput
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="outlined-adornment-password"
              type={"text"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton edge="end">{<SearchIcon />}</IconButton>
                </InputAdornment>
              }
              label="Search by Code, name, type..."
            />
          </FormControl>
        </div>
        {/* offers table */}
        <div>
          {filteredRows && filteredRows.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Offers Yet. All your Offers will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Coupons;
